import {ActionCreatorWithPayload} from "@reduxjs/toolkit";
import {VkApiError} from "../VkApiError";
import {IVkMethod} from "../IVkMethod";
import * as methods from "../methods/VkMethods";
import _chunk from "lodash/chunk";
import {UsersGetSubscriptionsParams} from "../methods/UsersGetSubscriptionsParams";
import {UserIdAnyIds} from "../objects/UserIdAnyIds";
import ExecuteUserIdGroupId from "./common/ExecuteUserIdGroupId";
import {TaskProgress} from "../../store/parsers/types";

export interface GetSubscriptionsOfEveryUserIdParams {
    user_ids: number[],
    access_token: string,
    method_params?: Partial<UsersGetSubscriptionsParams>,
    progress_action?: ActionCreatorWithPayload<TaskProgress>,
    add_api_errors_action?: ActionCreatorWithPayload<VkApiError>,
}

const GetSubscriptionsOfEveryUserId = function* (params: GetSubscriptionsOfEveryUserIdParams): Generator<any, UserIdAnyIds[], any> {
    const access_token = params.access_token;
    const executes:Array<IVkMethod> = prepare(params.user_ids, params.method_params);
    const executes_result: UserIdAnyIds[] = yield ExecuteUserIdGroupId(executes, access_token, params.progress_action, params.add_api_errors_action);
    return executes_result;
};

function prepare(user_ids: number[], method_params?: Partial<UsersGetSubscriptionsParams>): Array<IVkMethod> {

    const max_requests_per_execute: number = 25;

    const chunked_user_ids: number[][] = _chunk(user_ids, max_requests_per_execute);
    const executes: Array<IVkMethod> = chunked_user_ids.map((user_ids: number[]) => {
        const requests: string[] = user_ids.map((user_id: number) => {
            const method: IVkMethod = methods.usersGetSubscriptions({...{user_id: user_id}, ...method_params});
            return '{"user_id":' + user_id + ', "result":API.' + method.method_name + '(' + JSON.stringify(method.params) + ').groups}';
        });
        const code: string = "return [" + requests.join(",") + "];";
        return methods.execute({code: code});
    });
    return executes;
}

export default GetSubscriptionsOfEveryUserId;
